<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h2>{{ $t('integration.v2.7') }}</h2>
      <p>
        {{ $t('integration.v2.8') }}
      </p>
      <h2>{{ $t('integration.v2.9') }}</h2>
      <div class="z-card__body">
        <article class="mb-5">
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://module.sms.zorra.com/api/v1/mailings</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> POST</li>
            <li><b>Body:</b> JSON</li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
        </article>
        <p>{{ $t('integration.api.send_message_limit') }} <b>–</b></p>
        <p>{{ $t('integration.api.example') }}</p>
        <pre>
<code class="json hljs"> {
    <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
    <span class="hljs-attr">"start_at"</span>: <span class="hljs-string">"2023-03-23 23:23:23"</span>,
    <span class="hljs-attr">"mailing"</span>: <span class="hljs-string">"Test Mailing Name"</span>,
    <span class="hljs-attr">"body"</span>: <span class="hljs-string">"hello"</span>
    <span class="hljs-attr">"recipient"</span>: <span class="hljs-string">"79123456789"</span>
  }
</code>
        </pre>

        <p>
          {{ $t('integration.v2.10') }}
        </p>

        <ul class="list-unstyled integration-list-info">
          <li><b>sender</b> - {{ $t('integration.v2.11') }}</li>
          <li><b>mailing</b> - {{ $t('integration.v2.12') }}</li>
          <li><b>body</b> - {{ $t('integration.v2.13') }}</li>
          <li><b>recipient</b> - {{ $t('integration.v2.14') }}</li>
          <li><b>start_at</b> - {{ $t('integration.v2.15') }}</li>
        </ul>

        <h2>{{ $t('integration.v2.16') }}</h2>
        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://module.sms.zorra.com/api/v1/mailings</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> POST</li>
          <li><b>Body:</b> JSON</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>

        <p>{{ $t('integration.api.example') }}</p>
        <pre>
<code class="json hljs">{
    <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Zorra"</span>,
    <span class="hljs-attr">"start_at"</span>: <span class="hljs-string">"2023-03-23 23:23:23"</span>,
    <span class="hljs-attr">"mailing"</span>: <span class="hljs-string">"Test Mailing Name"</span>,
    <span class="hljs-attr">"body"</span>: <span class="hljs-string">"hello"</span>,
    <span class="hljs-attr">"recipients"</span>: {
        <span class="hljs-attr">"include"</span>: [
          {
            <span class="hljs-attr">"id"</span>: <span class="hljs-string">3759</span>,
            <span class="hljs-attr">"range"</span>:
              {
                <span class="hljs-attr">"from"</span>: <span class="hljs-string">1</span>,
                <span class="hljs-attr">"to"</span>: <span class="hljs-string">10</span>,
              }
          }
        ],
        <span class="hljs-attr">"exclude"</span>: [],
        <span class="hljs-attr">"extra_recipients"</span>: [
          {<span class="hljs-attr">"number"</span>: <span class="hljs-string">"+79999999999"</span>}
        ]
    }
}
</code>
        </pre>

        <p>{{ $t('integration.v2.17') }} <b>extra_recipients.</b></p>
        <p>{{ $t('integration.v2.18') }} <b>recipients.</b></p>

        <ul class="list-unstyled integration-list-info">
          <li><b>include</b> - {{ $t('integration.v2.19') }}</li>
          <li><b>id</b> - {{ $t('integration.v2.20') }}</li>
          <li><b>range</b> - {{ $t('integration.v2.21') }}</li>
          <li><b>from</b> - {{ $t('integration.v2.22') }}</li>
          <li><b>to</b> - {{ $t('integration.v2.23') }}</li>

          <div class="api-doc-hint">
            <div class="flex">
              <div class="mr-2">&#128161;</div>
              <p>{{ $t('integration.v2.24') }}</p>
            </div>
            <ul class="list-unstyled integration-list-info">
              <li>1. {{ $t('integration.v2.misha') }}</li>
              <li>2. {{ $t('integration.v2.andrey') }}</li>
              <li>3. {{ $t('integration.v2.dasha') }}</li>
            </ul>

            <p>
              {{ $t('integration.v2.25') }}
            </p>
          </div>

          <li><b>exclude</b> - {{ $t('integration.v2.26') }}</li>
          <li><b>extra_recipients</b> - {{ $t('integration.v2.27') }}</li>
        </ul>

        <h2>{{ $t('integration.v2.28') }}</h2>
        <p>
          {{ $t('integration.v2.29') }}
        </p>

        <p>{{ $t('integration.v2.30') }}</p>
        <pre>
<code class="json hljs">{
    <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Zorra"</span>,
    <span class="hljs-attr">"start_at"</span>: <span class="hljs-string">"2023-03-23 23:23:23"</span>,
    <span class="hljs-attr">"mailing"</span>: <span class="hljs-string">"Test Mailing Name"</span>,
    <span class="hljs-attr">"body"</span>: <span class="hljs-string">"Hello {name}. I am from {city}"</span>,
    <span class="hljs-attr">"recipients"</span>: {
        <span class="hljs-attr">"include"</span>: [
          {
            <span class="hljs-attr">"id"</span>: <span class="hljs-string">3759</span>,
            <span class="hljs-attr">"range"</span>:
              {
                <span class="hljs-attr">"from"</span>: <span class="hljs-string">1</span>,
                <span class="hljs-attr">"to"</span>: <span class="hljs-string">10</span>,
              }
          }
        ],
        <span class="hljs-attr">"exclude"</span>: [],
        <span class="hljs-attr">"extra_recipients"</span>: [
          {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"+79999999999"</span>,
            <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Анатолий"</span>,
            <span class="hljs-attr">"city"</span>: <span class="hljs-string">"Владикавказ"</span>,
          },
          {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"+71111111111"</span>,
            <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Antony"</span>,
            <span class="hljs-attr">"city"</span>: <span class="hljs-string">"New York"</span>,
          }
        ]
    }
}
</code>
        </pre>

        <p>
          {{ $t('integration.v2.31') }}
        </p>

        <p>
          {{ $t('integration.v2.32') }}
        </p>

        <article class="mb-5">
          <h2>{{ $t('integration.api.list_macros') }}:</h2>

          <ul class="list-unstyled integration-list-info">
            <li>name</li>
            <li>email</li>
            <li>first_name</li>
            <li>last_name</li>
            <li>age</li>
            <li>sex</li>
            <li>country</li>
            <li>city</li>
            <li>custom1</li>
            <li>custom2</li>
            <li>custom3</li>
            <li>custom4</li>
            <li>custom5</li>
          </ul>
        </article>

        <h2>{{ $t('integration.v2.33') }}</h2>

        <p>
          {{ $t('integration.v2.34') }}
        </p>

        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Zorra"</span>,
      <span class="hljs-attr">"mailing"</span>: <span class="hljs-string">"Test Mailing Name"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"Hello, {name}!"</span>,
      <span class="hljs-attr">"recipients"</span>: {
        <span class="hljs-attr">"include"</span>: <span>[]</span>,
        <span class="hljs-attr">"exclude"</span>: <span>[]</span>,
        <span class="hljs-attr">"extra_recipients"</span>: <span>[
          {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
            <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">"Greetings!"</span>
          },
          {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79992223333"</span>,
            <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Alex"</span>
          },
          {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79997777777"</span>
          }
        ]</span>
      }
  }
</code>
</pre>
        <p>
          {{ $t('integration.v2.35') }}
        </p>
        <p>«Hello, Alex!» {{ $t('integration.v2.36') }}</p>
        <p>«Hello, !» {{ $t('integration.v2.37') }}</p>

        <h2>{{ $t('integration.v2.38') }}</h2>
        <article class="mb-5">
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://module.sms.zorra.com/api/v1/mailings</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> GET</li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
        </article>

        <p>{{ $t('integration.api.answer_example') }}</p>

        <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"meta"</span>: {
      <span class="hljs-attr">"total"</span>: <span class="hljs-number">284</span>,
      <span class="hljs-attr">"items_per_page"</span>: <span class="hljs-number">10</span>,
      <span class="hljs-attr">"current_page"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"total_pages"</span>: <span class="hljs-number">29</span>  
    }
    <span class="hljs-attr">"data"</span>: [
      {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number"> 7937</span>,
        <span class="hljs-attr">"client_id"</span>: <span class="hljs-number"> 1111</span>,
        <span class="hljs-attr">"sender_id"</span>: <span class="hljs-number"> 3</span>,
        <span class="hljs-attr">"source_type"</span>: <span class="hljs-string"> "web"</span>,
        <span class="hljs-attr">"source_version"</span>: <span class="hljs-string"> "v3"</span>,
        <span class="hljs-attr">"status"</span>: <span class="hljs-string"> "moderation"</span>,
        <span class="hljs-attr">"rules"</span>: {
          <span class="hljs-attr">"recipients"</span>: [
            {
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"+79123456789"</span>
            }
          ] 
        },
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"TestBody"</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2023-03-06T13:40:06.000000Z"</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2023-03-06T13:40:06.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-number">"Mailing Name"</span>,
        <span class="hljs-attr">"single"</span>: <span class="hljs-number">false</span>,
        <span class="hljs-attr">"aggregated"</span>: <span class="hljs-number">false</span>
        <span class="hljs-attr">"start_at"</span>: <span class="hljs-number">null</span>
      },
      {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number"> 130</span>,
        <span class="hljs-attr">"client_id"</span>: <span class="hljs-number"> 1111</span>,
        <span class="hljs-attr">"sender_id"</span>: <span class="hljs-number"> 3</span>,
        <span class="hljs-attr">"source_type"</span>: <span class="hljs-string"> "api"</span>,
        <span class="hljs-attr">"source_version"</span>: <span class="hljs-string"> "v2"</span>,
        <span class="hljs-attr">"status"</span>: <span class="hljs-string"> "finished"</span>,
        <span class="hljs-attr">"rules"</span>: {
          <span class="hljs-attr">"recipients"</span>: [
            {
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"+79123456789"</span>
            }
          ]
        },
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"verification code 12345"</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2023-03-02T09:33:35.000000Z"</span>,
        <span class="hljs-attr">"updated_at"</span>: <span class="hljs-string">"2023-03-02T09:33:35.000000Z"</span>,
        <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-number">null</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Test Mailing Name"</span>,
        <span class="hljs-attr">"single"</span>: <span class="hljs-number">false</span>,
        <span class="hljs-attr">"aggregated"</span>: <span class="hljs-number">false</span>
        <span class="hljs-attr">"start_at"</span>: <span class="hljs-number">null</span>
      },
      ...
    ]
  }
  </code>
</pre>

        <p>{{ $t('integration.v2.39') }}</p>

        <p><b>name</b> - {{ $t('integration.v2.40') }}</p>

        <p><b>status</b> - {{ $t('integration.v2.41') }}</p>

        <p><b>created_at</b> - {{ $t('integration.v2.42') }}</p>

        <p><b>source_type</b> - {{ $t('integration.v2.43') }}</p>

        <p>{{ $t('integration.v2.44') }}</p>

        <p>{{ $t('integration.v2.45') }}</p>

        <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"source_type"</span>: <span class="hljs-string">"web"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Test Name"</span>,      
  }
  </code>
</pre>

        <h2>{{ $t('integration.v2.46') }}</h2>

        <article class="mb-5">
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://module.sms.zorra.com/api/v1/stats/messages/detailed</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> GET</li>
            <li>
              <b>Params:</b> start, end, mailing_name, mailing_id, number, status, sender,
              sort_direction, sort_column
            </li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
        </article>

        <p>{{ $t('integration.v2.47') }}</p>
        <p>{{ $t('integration.v2.48') }}</p>

        <p><b>"start"</b>: "yyyy-mm-dd hh:mm:ss" - {{ $t('integration.v2.49') }}</p>
        <p><b>"end"</b>: "yyyy-mm-dd hh:mm:ss", - {{ $t('integration.v2.50') }}</p>
        <p><b>"mailing_name"</b>: "test", - {{ $t('integration.v2.51') }}</p>

        <p><b>"mailing_id"</b>: 1, - {{ $t('integration.v2.52') }}</p>
        <p><b>"number"</b>: "7923", - {{ $t('integration.v2.53') }}</p>
        <p>
          <b>"status"</b>: "sent", - {{ $t('integration.v2.54') }}delivered, sent, pending,
          not_delivered, failed, rejected, expired, processing
        </p>
        <p>
          <b>"sender"</b>: "Brown1", - {{ $t('integration.v2.55') }}
          “source”
        </p>
        <p><b>"sort_direction"</b>: "desc", - {{ $t('integration.v2.56') }}</p>

        <p><b>"sort_column"</b>: "created_at" - {{ $t('integration.v2.57') }}</p>
        <p>{{ $t('integration.api.answer_example') }}</p>

        <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"meta"</span>: {
      <span class="hljs-attr">"total"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"items_per_page"</span>: <span class="hljs-number">20</span>,
      <span class="hljs-attr">"current_page"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"total_pages"</span>: <span class="hljs-number">1</span>  
    }
    <span class="hljs-attr">"data"</span>: [
      {
        <span class="hljs-attr">"part_group"</span>: <span class="hljs-string">"00dd1f19-bc90-4186-bc13-89311аcb3434",</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"mailing name",</span>,
        <span class="hljs-attr">"source_type"</span>: <span class="hljs-string">"api",</span>,
        <span class="hljs-attr">"status"</span>: <span class="hljs-string">"delivered",</span>,
        <span class="hljs-attr">"source"</span>: <span class="hljs-string">"Dostavim",</span>,
        <span class="hljs-attr">"destination"</span>: <span class="hljs-string">"79123456789",</span>,
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test ver code 123",</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2022-05-05 15:09:17",</span>,
        <span class="hljs-attr">"mailing_id"</span>: <span class="hljs-number">1,</span>,
        <span class="hljs-attr">"total_parts"</span>: <span class="hljs-number">1,</span>,
        <span class="hljs-attr">"client_cost"</span>: <span class="hljs-string">"6.80000000"</span>
      },
      {
        <span class="hljs-attr">"part_group"</span>: <span class="hljs-string">"01c655b4-128f-345c8-b993-dbe0ee1b83f0"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"mailing name"</span>,
        <span class="hljs-attr">"source_type"</span>: <span class="hljs-string">"web"</span>,
        <span class="hljs-attr">"status"</span>: <span class="hljs-string">"delivered"</span>,
        <span class="hljs-attr">"source"</span>: <span class="hljs-string">"Dostavim"</span>,
        <span class="hljs-attr">"destination"</span>: <span class="hljs-string">"79123456689"</span>,
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test ver code 123"</span>,
        <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2023-04-12 08:37:42"</span>,
        <span class="hljs-attr">"mailing_id"</span>: <span class="hljs-number">2</span>,
        <span class="hljs-attr">"total_parts"</span>: <span class="hljs-number">2</span>,
        <span class="hljs-attr">"client_cost"</span>: <span class="hljs-string">"13.60000000"</span>
      },
      ...
    ]
  }
  </code>
</pre>
        <h2>{{ $t('integration.v2.58') }}</h2>

        <article class="mb-5">
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://my.zorra.com/api/v2/stats/mailing/general</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> GET</li>
            <li>
              <b>Params:</b> date_from, date_to, group_by, source, sender, current_page,
              sort_direction, sort_column
            </li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
        </article>

        <p>{{ $t('integration.v2.59') }}</p>
        <p>{{ $t('integration.v2.60') }}</p>

        <p><b>"date_from"</b>: "yyyy-mm-dd hh:mm:ss" - {{ $t('integration.v2.49') }}</p>
        <p><b>"date_to"</b>: "yyyy-mm-dd hh:mm:ss", - {{ $t('integration.v2.50') }}</p>
        <p>
          <b>"group_by"</b>: "day", - {{ $t('integration.v2.61') }} day, mailing, country, network,
          sender - {{ $t('integration.v2.62') }}
        </p>
        <p><b>"source"</b>: "api", - {{ $t('integration.v2.63') }} web, api</p>
        <p><b>"sender"</b>: "Brown1", - {{ $t('integration.v2.64') }}</p>
        <p><b>"current_page"</b>: "1", - {{ $t('integration.v2.65') }}</p>
        <p><b>"sort_direction"</b>: "desc" - {{ $t('integration.v2.66') }}</p>

        <p><b>"sort_column"</b>: "caption" - {{ $t('integration.v2.67') }}</p>

        <p>{{ $t('integration.api.answer_example') }}</p>

        <pre>
  <code class="json hljs">
  {
    <span class="hljs-attr">"data"</span>: [
      {
        <span class="hljs-attr">"group_by"</span>: <span class="hljs-string"> "2022-06-22"</span>,
        <span class="hljs-attr">"total"</span>: <span class="hljs-string">"1"</span>,
        <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number">13</span>,
        <span class="hljs-attr">"client_cost_eur"</span>: <span class="hljs-string">"0.2313"</span>,
        <span class="hljs-attr">"pending"</span>: <span class="hljs-string">"0"</span>,
        <span class="hljs-attr">"processing"</span>: <span class="hljs-string">"0"</span>,
        <span class="hljs-attr">"failed"</span>: <span class="hljs-string"> "0"</span>,
        <span class="hljs-attr">"sent"</span>: <span class="hljs-string"> "0"</span>,
        <span class="hljs-attr">"delivered"</span>: <span class="hljs-string">"1"</span>,
        <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string">"0"</span>,
        <span class="hljs-attr">"expired"</span>: <span class="hljs-string">"0"</span>,
        <span class="hljs-attr">"rejected"</span>: <span class="hljs-string">"0"</span>,
        <span class="hljs-attr">"caption"</span>: <span class="hljs-string">"2022-06-22"</span>,
        <span class="hljs-attr">"cost"</span>: <span class="hljs-number">13</span>,
        <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-string"> "0.2313"</span>
      },
      {
        <span class="hljs-attr">"group_by"</span>: <span class="hljs-string"> "2022-06-30"</span>
        <span class="hljs-attr">"total"</span>: <span class="hljs-string"> "2"</span>
        <span class="hljs-attr">"client_cost"</span>: <span class="hljs-number"> 26</span>
        <span class="hljs-attr">"client_cost_eur"</span>: <span class="hljs-string"> "0.43"</span>
        <span class="hljs-attr">"pending"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"processing"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"failed"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"sent"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"delivered"</span>: <span class="hljs-string"> "2"</span>
        <span class="hljs-attr">"not_delivered"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"expired"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"rejected"</span>: <span class="hljs-string"> "0"</span>
        <span class="hljs-attr">"caption"</span>: <span class="hljs-string"> "2022-06-30"</span>
        <span class="hljs-attr">"cost"</span>: <span class="hljs-number"> 26</span>
        <span class="hljs-attr">"def_client_cost"</span>: <span class="hljs-string"> "0.43"</span>
      },
      ...
    ]
  }
  </code>
</pre>
      </div>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
